import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=f08a060c&scoped=true&"
import script from "./Hand.vue?vue&type=script&lang=js&"
export * from "./Hand.vue?vue&type=script&lang=js&"
import style0 from "./Hand.vue?vue&type=style&index=0&id=f08a060c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08a060c",
  null
  
)

export default component.exports